import React, { Component } from 'react';
import styled from 'styled-components';
import Tabs from 'components/Tabs';
import LightButton from 'components/LightButton';

import VisitSuggestionForm from 'components/Suggestions/VisitSuggestionForm';
import AcommodationPricingsForm from 'components/Suggestions/AcommodationPricings';
import AverageDailyExpenses from 'components/Suggestions/AverageDailyExpenses';
import ClimatesList from 'components/Suggestions/ClimatesList';
import LifecycleForm from 'components/Suggestions/Lifecycle';
import CuisineSpecialityForm from 'components/Suggestions/CuisineSpeciality';
import Loader from 'components/Loader';
import { Link } from 'react-router-dom';

const Container = styled.div`
  overflow-x: auto;
  display: block;
  max-width: 100%;
  padding: 25px;
`;
const DetailsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-bottom: 36px;
  min-width: 1000px;
  background: #fff;
  box-shadow: 0px 6px 18px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
`;
const Avatar = styled.img`
  border-radius: 5px;
  width: 300px;
  height: 200px;
`;
const Primary = styled.p`
  font-size: 13px;
  margin: 0px;
`;
const Secondary = styled.p`
  color: #9e9e9e;
  font-size: 13px;
  margin: 0px 5px 0px 0px;
`;
const FlexRow = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.width}%;
  margin-left: ${props => (props.marginLeft ? props.marginLeft : 0)}px;
  margin-right: ${props => (props.marginRight ? props.marginRight : 0)}px;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : 0)}px;
  height: ${props => props.height && props.height}px;
`;
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 450px;
`;
class CreateSuggestionForm extends Component {
  render() {
    const {
      tabs,
      token,
      cities,
      climate,
      country,
      isEditing,
      changePage,
      searchCity,
      getClimate,
      setClimate,
      currentPage,
      saveClimate,
      editClimate,
      climatesCount,
      renderAddCity,
      handleAddCity,
      handleModalExcel,
      renderModalExcel,
      elementsPerPage,
      onRemoveClimate,
      citySearchableText,
      loading,
      activeTab,
      weather,
      loadingData,
      handleisEditing,
      dailyExpenses,
      accommodationPricing,
      saveVisitSuggestion,
      editVisitSuggestion,
      saveAverageDailyExpenses,
      saveAccommodationPricing,
      getLifecyclesRequest,
      searchLifeCycle,
      cuisineSearchableText,
      searchCuisine,
      getLifecycleRequest,
      removeLifecycleRequest,
      saveLifecycle,
      onShowLifecycleForm,
      lifecycles,
      lifecycle,
      lifecycleCount,
      lifecycleCurrentPage,
      loadingLifecycle,
      showLifecycleForm,
      getCuisineSpecialitiesRequest,
      getCuisineSpecialityRequest,
      removeCuisineSpecialityRequest,
      saveCuisineSpeciality,
      onShowCuisineSpecialityForm,
      cuisineSpecialities,
      cuisineSpeciality,
      cuisineSpecialityCount,
      cuisineSpecialityCurrentPage,
      loadingCuisineSpeciality,
      showCuisineSpecialityForm,
      lifecyclesearchable,
      regionsForSelect,
      citiesForSelect,
      getCitiesForSelect,
      match: { params },
    } = this.props;
    return (
      <>
        {loading ? (
          <LoaderContainer>
            <Loader type="pulse" size={125} />
          </LoaderContainer>
        ) : (
          <Container>
            <DetailsContainer>
              <FlexRow>
                <Avatar src={country.flag} />
                <FlexColumn width={25} style={{ margin: 20 }}>
                  <FlexRow style={{ marginBottom: 40 }}>
                    <Secondary>Name: </Secondary>
                    <Primary>{country.name}</Primary>
                  </FlexRow>
                  <FlexRow style={{ marginBottom: 40 }}>
                    <Secondary>Timezone: </Secondary>
                    <Primary>{country.timezone}</Primary>
                  </FlexRow>
                  <FlexRow>
                    <Secondary>Latitude Capital: </Secondary>
                    <Primary>{country.latitude_capital}°</Primary>
                  </FlexRow>
                </FlexColumn>
                <FlexColumn width={25} style={{ margin: 20 }}>
                  <FlexRow style={{ marginBottom: 40 }}>
                    <Secondary>Capital: </Secondary>
                    <Primary>{country.capital}</Primary>
                  </FlexRow>
                  <FlexRow style={{ marginBottom: 40 }}>
                    <Secondary>Currency: </Secondary>
                    <Primary>{country.currency}</Primary>
                  </FlexRow>
                  <FlexRow>
                    <Secondary>Longitude Capital: </Secondary>
                    <Primary>{country.longitude_capital}°</Primary>
                  </FlexRow>
                </FlexColumn>
                <FlexColumn width={25} style={{ margin: 20 }}>
                  <FlexRow style={{ marginBottom: 40 }}>
                    <Secondary>Region: </Secondary>
                    <Primary>{country.subregion}</Primary>
                  </FlexRow>
                  <FlexRow>
                    <Secondary>Phone code: </Secondary>
                    <Primary>{country.phone_code}</Primary>
                  </FlexRow>
                </FlexColumn>

                <FlexColumn width={25} style={{ margin: 20 }}>
                  <FlexRow style={{ marginBottom: 40, justifyContent: 'flex-end' }}>
                    <Link to={`/regions/country/${country.id}`}>
                      <LightButton>Manage Regions </LightButton>
                    </Link>
                  </FlexRow>
                  <FlexRow style={{ justifyContent: 'flex-end' }}>
                    <Link to={`/cities/country/${country.id}`}>
                      <LightButton>Manage Cities </LightButton>
                    </Link>
                  </FlexRow>
                </FlexColumn>
              </FlexRow>
            </DetailsContainer>
            <Tabs tabs={tabs} active={activeTab} />
            {loadingData ? (
              <LoaderContainer>
                <Loader type="pulse" size={125} />
              </LoaderContainer>
            ) : (
              <>
                {activeTab === 'Climates' && (
                  <ClimatesList
                    token={token}
                    cities={cities}
                    country={country}
                    climate={climate}
                    isEditing={isEditing}
                    changePage={changePage}
                    searchCity={searchCity}
                    getClimate={getClimate}
                    setClimate={setClimate}
                    saveClimate={saveClimate}
                    editClimate={editClimate}
                    currentPage={currentPage}
                    renderAddCity={renderAddCity}
                    handleAddCity={handleAddCity}
                    renderModalExcel={renderModalExcel}
                    handleModalExcel={handleModalExcel}
                    climatesCount={climatesCount}
                    onRemoveClimate={onRemoveClimate}
                    handleisEditing={handleisEditing}
                    elementsPerPage={elementsPerPage}
                    citySearchableText={citySearchableText}
                    searchLifeCycle={searchLifeCycle}
                    regionsForSelect={regionsForSelect}
                    citiesForSelect={citiesForSelect}
                    getCitiesForSelect={getCitiesForSelect}
                  />
                )}
                {activeTab === 'Visit Suggestions' && (
                  <VisitSuggestionForm
                    token={token}
                    country={country}
                    weather={weather}
                    renderModalExcel={renderModalExcel}
                    handleModalExcel={handleModalExcel}
                    saveVisitSuggestion={saveVisitSuggestion}
                    editVisitSuggestion={editVisitSuggestion}
                  />
                )}
                {activeTab === 'AVG Daily Expenses' && (
                  <AverageDailyExpenses
                    token={token}
                    country={country}
                    dailyExpenses={dailyExpenses}
                    renderModalExcel={renderModalExcel}
                    handleModalExcel={handleModalExcel}
                    saveAverageDailyExpenses={saveAverageDailyExpenses}
                  />
                )}
                {activeTab === 'Accommodation Pricings' && (
                  <AcommodationPricingsForm
                    token={token}
                    country={country}
                    renderModalExcel={renderModalExcel}
                    handleModalExcel={handleModalExcel}
                    accommodationPricing={accommodationPricing}
                    saveAccommodationPricing={saveAccommodationPricing}
                  />
                )}
                {activeTab === 'Lifecycle' && (
                  <LifecycleForm
                    token={token}
                    country={country}
                    renderModalExcel={renderModalExcel}
                    handleModalExcel={handleModalExcel}
                    find={getLifecyclesRequest}
                    findOne={getLifecycleRequest}
                    remove={removeLifecycleRequest}
                    save={saveLifecycle}
                    switchFormShow={onShowLifecycleForm}
                    list={lifecycles}
                    item={lifecycle}
                    count={lifecycleCount}
                    currentPage={lifecycleCurrentPage}
                    loading={loadingLifecycle}
                    showForm={showLifecycleForm}
                    countryId={params.id}
                    lifecyclesearchable={lifecyclesearchable}
                    searchLifeCycle={searchLifeCycle}
                    regionsForSelect={regionsForSelect}
                    citiesForSelect={citiesForSelect}
                    getCitiesForSelect={getCitiesForSelect}
                  />
                )}

                {activeTab === 'Cuisine specialities' && (
                  <CuisineSpecialityForm
                    token={token}
                    country={country}
                    renderModalExcel={renderModalExcel}
                    handleModalExcel={handleModalExcel}
                    cuisineSearchableText={cuisineSearchableText}
                    searchCuisine={searchCuisine}
                    find={getCuisineSpecialitiesRequest}
                    findOne={getCuisineSpecialityRequest}
                    remove={removeCuisineSpecialityRequest}
                    save={saveCuisineSpeciality}
                    switchFormShow={onShowCuisineSpecialityForm}
                    list={cuisineSpecialities}
                    item={cuisineSpeciality}
                    count={cuisineSpecialityCount}
                    currentPage={cuisineSpecialityCurrentPage}
                    loading={loadingCuisineSpeciality}
                    showForm={showCuisineSpecialityForm}
                    countryId={params.id}
                    regionsForSelect={regionsForSelect}
                    citiesForSelect={citiesForSelect}
                    getCitiesForSelect={getCitiesForSelect}
                  />
                )}
              </>
            )}
          </Container>
        )}
      </>
    );
  }
}
export default CreateSuggestionForm;
